function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".a{fill:#b1b7d8;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "a",
  d: "M158,22V35h-5.936c-.731,1.362-.4.792-1.619,2.805a.466.466,0,0,1-.366.227.4.4,0,0,1-.363-.178A18.133,18.133,0,0,1,148.109,35H142V22h16m2-2H140V37h7.046c.8,1.5,1.344,3,3.033,3,1.782,0,2.075-1.222,3.037-3H160V20Z",
  transform: "translate(-140 -20)"
});

var SvgMessage = function SvgMessage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 20,
    height: 20.001,
    viewBox: "0 0 20 20.001",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMessage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/message.e6d366d8.svg";
export { ForwardRef as ReactComponent };